import { RoleType } from '../generated/types';

const ORGANIZATION_ROLE_TYPES = [RoleType.OrganizationAdmin, RoleType.OrganizationReader];

const EVENT_ROLE_TYPES = [RoleType.EventAdmin, RoleType.EventReader];

export const ORGANIZATION_EVENT_ROLE_TYPES = ORGANIZATION_ROLE_TYPES.concat(EVENT_ROLE_TYPES);
